/* DSL GTM wrapper — load Google Tag Manager only after analytics consent */
(function(){
  var CFG = window.DSL_CONFIG || {};
  if (!CFG.gtmContainerId) return;
  function load(){
    if (window.__dslGtmLoaded) return;
    window.__dslGtmLoaded = true;
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start": new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=="dataLayer"?"&l="+l:"";j.async=true;j.src="https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);})(window,document,"script","dataLayer", CFG.gtmContainerId);
  }
  function check(){
    var c = window.DSL_CONSENT && window.DSL_CONSENT.get();
    if (c && c.analytics) load();
  }
  document.addEventListener("dsl:consent:change", check);
  setTimeout(check, 1000);
})();